import { hotFeatured, hotList } from "@/mocks/freegua";

export default function HotBoard() {
  return (
    <section id="today" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-bold text-secondary-800">
              <i className="ri-fire-line" aria-hidden="true" />
              实时热度
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今日吃瓜速览
            </h2>
            <p className="mt-3 max-w-xl text-base text-foreground-600">
              免费吃瓜零元看今天最热门的素材，截图与时间线都排好了，点开就能从前往后看。
            </p>
          </div>
          <a
            href="#channels"
            className="inline-flex items-center whitespace-nowrap text-sm font-bold text-primary-700 hover:text-primary-800"
          >
            更多题材在频道里
            <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-5">
          {/* 大主卡 */}
          <article className="hover-lift group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 lg:col-span-3">
            <div className="relative h-64 w-full overflow-hidden md:h-80">
              <img
                src={hotFeatured.img}
                alt={hotFeatured.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/5 to-transparent" />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                {hotFeatured.tag}
              </span>
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-xs font-medium text-background-50">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true" />
                  {hotFeatured.time}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {hotFeatured.views}
                </span>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <h3 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                {hotFeatured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{hotFeatured.text}</p>
              <div className="mt-5 flex flex-wrap items-center gap-2">
                {["首波截图", "时间线", "双方回应"].map((t) => (
                  <span
                    key={t}
                    className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700"
                  >
                    {t}
                  </span>
                ))}
                <a
                  href="#follow"
                  className="ml-auto inline-flex items-center whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-bold text-background-50 hover:bg-accent-600"
                >
                  免费吃瓜直接看
                </a>
              </div>
            </div>
          </article>

          {/* 小卡列表 */}
          <div className="grid gap-5 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-1">
            {hotList.map((h, i) => (
              <a
                href="#topics"
                key={h.title}
                className={`hover-lift group flex items-start gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-4 ${
                  i === 0 ? "lg:border-accent-300 lg:ring-1 lg:ring-accent-200" : ""
                }`}
              >
                <span
                  className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-black text-background-50 ${
                    i === 0 ? "bg-accent-500" : "bg-background-300"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-bold text-secondary-800">
                    {h.tag}
                  </span>
                  <h3 className="mt-2 line-clamp-2 text-sm font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                    {h.title}
                  </h3>
                  <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" aria-hidden="true" />
                      {h.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {h.views}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}